// mocked services
import MockAddressService from "./services/mocks/mockAddressService";
import MockAppointmentService from "./services/mocks/mockAppointmentService";
import MockBookingsService from "./services/mocks/mockBookingsService";
import MockContactsService from "./services/mocks/mockContactsService";
import MockCoverageService from "./services/mocks/mockCoverageService";
import MockFAQService from "./services/mocks/mockFAQService";
import MockFondoEstPerTeService from "./services/mocks/mockFondoEstPerTe";
import MockLoginService from "./services/mocks/mockLoginService";
import MockNotificationsService from "./services/mocks/mockNotificationsService";
import MockProfileService from "./services/mocks/mockProfileService";
// remote services
import AddressServiceImpl from "./services/addressServiceImpl";
import AppointmentServiceImpl from "./services/appointmentService";
import BookingsServiceImpl from "./services/bookingsService";
import CoverageServiceImpl from "./services/coverageService";
import DocumentsServiceImpl from "./services/documentService";
import ExternalServiceImpl from "./services/externalService";
import FondoEstPerTeServiceImpl from "./services/fondoEstPerTeService";
import LoginServiceImpl from "./services/loginServiceImpl";
import NotificationService from "./services/notificationService";
import ProfileServiceImpl from "./services/profileServiceImpl";

/**
 * This script decouples the logic to backend, every service is intended to be called
 * and instanced only from the store script associated, it's not an abstract level to
 * call services
 */
let AddressService;
let AppointmentService;
let BookingsService;
let ContactsService;
let CoverageService;
let DocumentsService;
let ExternalService;
let FaqService;
let FondoEstPerTeService;
let LoginService;
let NotificationsServiceImp;
let ProfileService;

if (process.env.VUE_APP_MOCK_SERVICES) {
  AddressService = new MockAddressService();
  AppointmentService = new MockAppointmentService();
  BookingsService = new MockBookingsService();
  ContactsService = new MockContactsService();
  CoverageService = new MockCoverageService();
  FaqService = new MockFAQService();
  FondoEstPerTeService = new MockFondoEstPerTeService();
  LoginService = new MockLoginService();
  NotificationsServiceImp = new MockNotificationsService();
  ProfileService = new MockProfileService();
} else {
  AddressService = new AddressServiceImpl();
  AppointmentService = new AppointmentServiceImpl(); // new MockAppointmentService();
  BookingsService = new BookingsServiceImpl(); // new MockBookingsService();
  ContactsService = new MockContactsService();
  CoverageService = new CoverageServiceImpl(); // new MockCoverageService();
  DocumentsService = new DocumentsServiceImpl();
  ExternalService = new ExternalServiceImpl();
  FaqService = new MockFAQService();
  FondoEstPerTeService = new FondoEstPerTeServiceImpl();
  LoginService = new LoginServiceImpl(); // new MockLoginService();
  NotificationsServiceImp = new NotificationService(); // new MockNotificationsService();
  ProfileService = new ProfileServiceImpl(); // new MockProfileService();
}

const services = {
  addressService: AddressService,
  loginService: LoginService,
  profileService: ProfileService,
  coverageService: CoverageService,
  fondoEstPerTeService: FondoEstPerTeService,
  contactsService: ContactsService,
  faqService: FaqService,
  notificationsService: NotificationsServiceImp,
  bookingsService: BookingsService,
  appointmentService: AppointmentService,
  documentService: DocumentsService,
  externalService: ExternalService
};

export default services;
